import React, { Component } from "react";
import { Step, StepList } from "@react/react-spectrum/StepList";
import { ContentMap } from "../config/contentMap";
import { MakeButton, ButtonMap } from "../content/Common/CommonButtonsComp";
import { connect } from "react-redux";
import { getFormValues, reduxForm } from "redux-form";
import {
  incrementStage,
  decrementStage,
  nextButtonUpdate,
  detailsAvailableToProceed,
} from "../storeManagement/action";
import { isSavingToggle } from "../../actions/commonActions";
// i18n
import { Translate } from "react-redux-i18n";
import "./regPage.css";
import { Grid, GridRow, GridColumn } from "@react/react-spectrum/Grid";
import Wait from "@react/react-spectrum/Wait";
import throwError from "../../comps/errorToast";
// TODO(sanctions-ru-by): RU/BY banner — controlled by SANCTIONS_RU_BY_VALIDATION_ENABLED
import RestrictedCountryBanner from "../../components/RestrictedCountryBanner";
import { isRestrictedSanctionCountry } from "../../utils/restrictedSanctionCountry";

class RegPage extends Component {
  constructor(props) {
    super(props);
    this.multiSelects = ["companyType"];
  }

  state = {
    formInitialized: false,
  };

  componentDidMount() {
    let initFields = {
      firstName_0: this.props?.profile?.first_name,
      lastName_0: this.props?.profile?.last_name,
      email_0: this.props?.profile?.email,
    };

    let isAllRequiredDataAvailable = true;

    if (
      this.props?.searchData?.code &&
      this.props?.searchData?.code === "10004"
    ) {
      initFields = this.props.searchData?.partnerInfo;

      initFields = {
        ...initFields,
        iCertify: true,
      };

      // Check if the "partnerInfo" exists
      if (initFields && _.keys(initFields)?.length > 0) {
        // Check for rec id
        if (initFields?.recId) {
          isAllRequiredDataAvailable = true;
          initFields["accountId"] = initFields?.recId;
          initFields?.recId ? delete initFields?.recId : null;

          initFields = {
            ...initFields,
            ...this.getGeo(this.props?.searchData?.partnerInfo?.billingCountry),
          };
        } else {
          isAllRequiredDataAvailable = false;
        }
      } else {
        isAllRequiredDataAvailable = false; // The required data to go further is not available from the api response, so stop the user from going forward.
      }

      // Common keys in initFields
      initFields = {
        ...initFields,
        ...this.getContacts(this.props?.searchData?.contacts),
      };

      Object.keys(initFields).map((key) => {
        if (this.multiSelects.includes(key)) {
          initFields[key] = initFields[key]?.split(";");
        }
        return null;
      });

      if (!isAllRequiredDataAvailable) {
        this.props.onDetailsAvailableToProceed(false);

        throwError(
          "We have encountered an error while fetching some of your details, kindly try after sometime or contact Helpdesk.",
        );
      }
    }

    this.props.initialize(initFields);
    this.setState({ formInitialized: true });
  }

  getContacts = (contacts) => {
    let retObj = {};
    let otherContactCounter = 2;
    contacts?.map((obj, index) => {
      let counter = otherContactCounter;
      if (obj["mainContactType"] === "Primary") {
        counter = 0;
      } else if (obj["mainContactType"] === "Secondary") {
        counter = 1;
      } else {
        otherContactCounter += 1;
      }
      Object.keys(obj).map((ele) => {
        retObj[ele === "recId" ? "contactId_" + counter : ele + "_" + counter] =
          ele === "additionalContactType" ? obj[ele].split(";") : obj[ele];
        return null;
      });
      return null;
    });
    return retObj;
  };

  handleNextNavigation = () => {
    this.props.onNextButton();
  };

  handlePreviousNavigation = () => {
    this.props.onPreviousButton();
  };

  getGeo = (billingCountry) => {
    let retObj = { geo: "" };
    Object.keys(this.props?.geoPolData).map((key) => {
      let obj = this.props?.geoPolData[key];
      if (obj.countries.hasOwnProperty(billingCountry)) {
        retObj.geo = obj.value;
      }
      return null;
    });
    return retObj;
  };

  render() {
    const currentStage = this.props?.currentStage;
    var TAG = ContentMap.forms[currentStage].component;
    var allbuttonFunc = {
      onNextButton: this.handleNextNavigation,
      onPreviousButton: this.handlePreviousNavigation,
      onSubmitButton: this.props.onSubmitButton,
    };
    var buttonRowNo = this.props.isSaveAndExit
      ? ButtonMap.length - 1
      : currentStage;
    const billingCountry =
      this.props.registration?.billingCountry ||
      this.props.searchData?.partnerInfo?.billingCountry;
    const isSanctionRestricted = isRestrictedSanctionCountry(billingCountry);

    return (
      <div>
        {this.props?.isSaving ? (
          <div className="overlay">
            <Wait size="L" centered />
            <span className="saving-Text">Saving</span>
          </div>
        ) : null}
        <Grid>
          <RestrictedCountryBanner visible={isSanctionRestricted} />
        </Grid>
        <StepList
          id="steplist-id"
          aria-labelledby="steplist-heading-id steplist-id"
          interaction="off"
          selectedIndex={currentStage}
        >
          <Step>
            <Translate value="registration.ONBLangPref" />
          </Step>
          <Step>
            <Translate value="registration.OnbrdCriteriaHeader" />
          </Step>
          <Step>
            <Translate value="registration.ONBCompInfo" />
          </Step>
          <Step>
            <Translate value="registration.Add_Contacts" />
          </Step>
          <Step>
            <Translate value="registration.ONBPgmAgreement" />
          </Step>
          {/* <Step><Translate value="registration.stepList.Finish" /></Step> */}
        </StepList>
        {this.state?.formInitialized ? (
          <TAG onValidateChange={this.props.onValidateChange} {...this.props} />
        ) : null}
        <Grid>
          <GridRow className="common-button-row">
            <GridColumn size={[12, 8, 6, 6]} offsetSize={[0, 2, 3, 3]}>
              <MakeButton
                btn={ButtonMap[buttonRowNo]}
                allbuttonFunc={allbuttonFunc}
                {...this.props}
              />
            </GridColumn>
          </GridRow>
        </Grid>
      </div>
    );
  }
}

RegPage = reduxForm({
  form: "registration",
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(RegPage);

const mapStateToProps = (state) => ({
  currentStage: state.registration.currentStage,
  isSaveAndExit: state.registration.isSaveAndExit,
  isSaving: state.common.isSaving,
  geoPolData: state.common.geoPolData,
  profile: state.ims.userProfile,
  registration: getFormValues("registration")(state),
});

const mapDispatchToProps = (dispatch) => ({
  is_saving: (e) => dispatch(isSavingToggle(e)),
  onNextButton: () => dispatch(incrementStage()),
  onPreviousButton: () => dispatch(decrementStage()),
  onValidateChange: (bool) => dispatch(nextButtonUpdate(bool)),
  onDetailsAvailableToProceed: (bool) =>
    dispatch(detailsAvailableToProceed(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegPage);
